/* TMF · size chart units (in/cm) + Fabric & fit style tabs that follow the "Style" option.
   Loaded by snippets/tmf-size-chart.liquid (may be included several times -> guard). No dependencies. */
(function () {
  if (window.__tmfFit) return;
  window.__tmfFit = true;

  var KEY = 'tmf-unit';

  function getUnit() {
    try { return localStorage.getItem(KEY) === 'cm' ? 'cm' : 'in'; } catch (e) { return 'in'; }
  }

  function applyUnit(u) {
    document.querySelectorAll('[data-tmf-units]').forEach(function (box) {
      box.classList.toggle('tmf-unit-cm', u === 'cm');
      box.querySelectorAll('[data-tmf-unit]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-tmf-unit') === u));
      });
    });
  }

  function selectTab(root, idx, focus) {
    if (!root) return;
    root.querySelectorAll('[data-tmf-tab]').forEach(function (t) {
      var on = t.getAttribute('data-tmf-tab') === String(idx);
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
    });
    root.querySelectorAll('[data-tmf-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-tmf-panel') !== String(idx);
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-tmf-unit]');
    if (b) {
      var u = b.getAttribute('data-tmf-unit');
      try { localStorage.setItem(KEY, u); } catch (x) { /* private mode */ }
      applyUnit(u);
      return;
    }
    var t = e.target.closest && e.target.closest('[data-tmf-tab]');
    if (t) selectTab(t.closest('[data-tmf-fit]'), t.getAttribute('data-tmf-tab'), false);
    if (e.target.closest && e.target.closest('[data-tmf-open]')) setTimeout(function () { applyUnit(getUnit()); }, 30);
  });

  document.addEventListener('keydown', function (e) {
    var t = e.target.closest && e.target.closest('[data-tmf-tab]');
    if (!t || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(t.parentNode.querySelectorAll('[data-tmf-tab]'));
    var i = tabs.indexOf(t) + (e.key === 'ArrowRight' ? 1 : -1);
    i = (i + tabs.length) % tabs.length;
    selectTab(t.closest('[data-tmf-fit]'), tabs[i].getAttribute('data-tmf-tab'), true);
    e.preventDefault();
  });

  // Follow the variant picker: radio inputs and <select> options carry data-option-name (Horizon).
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.getAttribute) return;
    var name = el.getAttribute('data-option-name');
    var val = el.value;
    if (el.tagName === 'SELECT') {
      var o = el.options[el.selectedIndex];
      name = o && o.getAttribute('data-option-name');
      val = o && o.value;
    }
    if (!name || !val) return;
    name = name.toLowerCase().trim();
    val = val.toLowerCase().trim();
    document.querySelectorAll('[data-tmf-fit]').forEach(function (root) {
      if ((root.getAttribute('data-style-option') || 'style') !== name) return;
      root.querySelectorAll('[data-tmf-tab]').forEach(function (t) {
        var vals = (t.getAttribute('data-values') || '').split('|');
        if (vals.indexOf(val) !== -1) selectTab(root, t.getAttribute('data-tmf-tab'), false);
      });
    });
  });

  function init() { applyUnit(getUnit()); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
